import React , {useState, useEffect,useContext} from "react";
import "./StudentsSubmissions.css";
import { GettingAll } from "../../../Functions/CRUD/Submission/submissionHelper";
import SubmissionTable from "./SubmissionTable/SubmissionTable";
import { test } from "../../../Status";
import LoadingPage from "../../../Error/LoadingPage/LoadingPage";
import { AuthContext } from "../../../context/authContext";


const StudentsSubmission = () => {
  const [SubmissionTri, setSubmissionTri] = useState("");   
  const [AllSubmissions, setAllSubmissions] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { user } = useContext(AuthContext);

  const fetchAllSubmissions = async (currentPage = 1) => {
    try {
      const data = await GettingAll(currentPage, 10); 
      // append results when loading more
      setAllSubmissions(prev => currentPage === 1 ? data.submissions : [...prev, ...data.submissions]);
      setTotalPages(data.totalPages);
    } catch (err) {
      console.error("Error fetching submissions:", err);
    }
  };

  useEffect(() => {
    fetchAllSubmissions(1);
  }, []);

  const loadMore = () => {
    if (page < totalPages) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchAllSubmissions(nextPage);
    }
  };

  if (!AllSubmissions.length) {
    return <LoadingPage />;
  }

  return (
    <div className="StudentsSubmission">
      <div className="Intro">
        <h1>🐘 Correcting Submissions :</h1>
        <p> For correctors and coordinators, this section is your gate to access students' submissions. We encourage you to assume the responsibility of making the learning experience more preferable for students, hence strengthnening their problem-solving abilities. Be patient and comprehensive, read the correction guide carefully and make a difference.  </p>
      </div>

      <div className="SubmissionTri">
        <h2>Students' Submissions :</h2>
        <select onChange={(e)=>setSubmissionTri(e.target.value)} defaultValue="">
          <option value="">All Submissions</option>
          <option value="My Submissions">My Submissions</option>
          <option value="On hold">On hold</option>
          <option value="in process">in process</option>
          <option value="correct">correct</option>
          <option value="incorrect">incorrect</option>
        </select>
      </div>

      <SubmissionTable 
        AllSubmissions={
          SubmissionTri === "" 
            ? AllSubmissions 
            : SubmissionTri === "My Submissions"
              ? AllSubmissions.filter(sub => sub.coordinator._id === user._id) 
              : AllSubmissions.filter(sub => sub.result === SubmissionTri.toLowerCase())
        } 
      />

      {page < totalPages && (
        <button onClick={loadMore} className="LoadMoreBtn">
          Load More
        </button>
      )}
    </div>
  );
};


/* const StudentsSubmission = () => {
const [SubmissionTri, setSubmissionTri] = useState("")   
const [AllSubmissions, setAllSubmissions] = useState(null);
const {user}=useContext(AuthContext)

const fetchAllSubmissions = async () => {
  try {
    const data = await GettingAll(); // no need to pass {} unless you have params
    console.log(data);
    setAllSubmissions(data);
  } catch (err) {
    console.error("Error fetching submissions:", err);
  }
};

useEffect(() => {
  fetchAllSubmissions();
}, []);

if (!AllSubmissions) {
  return <LoadingPage/>;
}

  return (
    <div className="StudentsSubmission">
      <div className="Intro">
        <h1>🐘 Correcting Submissions :</h1>
        <p>
            <b>Instructions : </b>
          In the Corrections section of the website, please ensure you carefully
          review students' submissions and provide clear, constructive feedback.
          Before proceeding, we highly recommend reading the{" "}
          <a href="#">Correction Guide</a> to maintain consistency in grading
          and comments. This guide outlines best practices, common pitfalls, and
          formatting standards to help you deliver high-quality corrections
          efficiently. If you have any questions, don’t hesitate to reach out.
          Thank you for your dedication to supporting students’ growth!
        </p>
      </div>
     

       <div className="SubmissionTri">
        <h2>Students' Submissions :</h2>
        <select name="" id="" defaultValue="" onChange={(e)=>setSubmissionTri(e.target.value)}>
          <option value="">All Submissions</option>
          <option value="My Submissions">My Submissions</option>
          <option value="On hold">On hold</option>
          <option value="in process">in process</option>
          <option value="correct">correct</option>
          <option value="incorrect">incorrect</option>

        </select>
       </div>
      <SubmissionTable AllSubmissions={SubmissionTri === "" ? AllSubmissions :SubmissionTri === "My Submissions"? AllSubmissions.filter(submission=>submission.coordinator._id === user._id):AllSubmissions.filter(submission => submission.result === SubmissionTri.toLowerCase())}/>
    </div>
  );
}; */

export default StudentsSubmission;
